import { useMemo } from 'react';
import { useServiceJobTypes } from 'pos-client/hooks/useServiceJobTypes.ts';
import { trpc } from 'pos-client/utils/trpc.ts';
import { mapJobTypeTimeslotsToServiceAvailability } from 'pos-shared/mappers/mapToServiceAvailability';
import type { ServiceTypesRequestModel } from 'pos-shared/models/schedulingSchema.ts';
import type {
  ServiceAvailabilityConfigFEModel,
  ServiceAvailabilityInfoType,
  ServiceMatrixFEModel,
} from 'pos-shared/models/serviceAvailabilitySchema.ts';

export const useServiceAvailability = (locationId: string) => {
  const { jobTypes, isLoadingJobTypes } = useServiceJobTypes();

  const { data: timeSlotSettings, isLoading: timeSlotsIsLoading } =
    trpc.locations.findTimeSlotSettings.useQuery({ resultsPerPage: 10000 }); //TODO: this has to be re-written when servce availability page get new design
  const serviceMatrixConfiguration:
    | ServiceAvailabilityConfigFEModel
    | undefined = useMemo(() => {
    if (!jobTypes || !timeSlotSettings?.results) {
      return undefined;
    }

    return mapJobTypeTimeslotsToServiceAvailability(
      jobTypes,
      timeSlotSettings?.results
    );
  }, [jobTypes, timeSlotSettings]);

  const {
    data: servicesData,
    isLoading: servicesDataIsLoading,
    refetch: refetchServicesData,
  } = trpc.locations.getServiceAvailability.useQuery(
    {
      serviceLocationId: locationId,
      resultsPerPage: 10000,
    },
    {
      enabled: !!serviceMatrixConfiguration,
    }
  );

  const initalData = (
    newTableData: ServiceMatrixFEModel[]
  ): ServiceMatrixFEModel[] => {
    newTableData.forEach((category: ServiceMatrixFEModel) => {
      const foundService = servicesData?.results?.find(
        (service: ServiceAvailabilityInfoType) =>
          service.jobTypeId === category.productCategoryId
      ) as { availabilityTimeIds: string[]; jobTypeId: string };

      category.availabilities.forEach((availability) => {
        availability.timeslots.forEach((timeslot) => {
          timeslot.isSelected = false;
        });
      });

      if (foundService) {
        category.availabilities.forEach((availability) => {
          availability.timeslots.forEach((timeslot) => {
            timeslot.isSelected = foundService.availabilityTimeIds?.some(
              (foundServiceAvailability) =>
                foundServiceAvailability === timeslot.timeslotId
            );
          });
        });
      }
    });

    return newTableData;
  };

  const filterData = (
    newTableData: ServiceMatrixFEModel[],
    serviceTypeFilter: ServiceTypesRequestModel
  ): ServiceMatrixFEModel[] => {
    const filtered = newTableData.filter(
      (item) => item.productCategoryServiceType === serviceTypeFilter
    );

    filtered.sort((a, b) => {
      const nameA = a.productCategoryTitle.toUpperCase(); // ignore upper and lowercase
      const nameB = b.productCategoryTitle.toUpperCase(); // ignore upper and lowercase
      return nameA.localeCompare(nameB);
    });

    return filtered;
  };

  return {
    isLoading: isLoadingJobTypes || timeSlotsIsLoading || servicesDataIsLoading,
    servicesData,
    serviceMatrixConfiguration,
    refetchServicesData,
    initalData,
    filterData,
  };
};
